import { render } from "./LostCallsCard.vue?vue&type=template&id=12b1efe2"
import script from "./LostCallsCard.vue?vue&type=script&lang=js"
export * from "./LostCallsCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__